import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Projects from './Projects';
import Wall from './Wall';


function App() {
  return (
    <BrowserRouter>
      <Background />
      <Navbar />
      <Oneko />
      <Routes>
        <Route
          path="/"
          element={
            <div className="container">
              <Profile />
            </div>
          }
        />
        <Route
          path="/projects"
          element={
            <div className="container">
              <Projects />
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

function Oneko(){
  useEffect(() => {
    // Clean up any previous instance before adding
    if (window.oneko && typeof window.oneko.destroy === 'function') {
      window.oneko.destroy();
    }

    // Only add the script if not already present
    if (!document.getElementById('oneko-script')) {
      const script = document.createElement('script');
      script.src = process.env.PUBLIC_URL + '/oneko.js';
      script.async = true;
      script.id = 'oneko-script';
      document.body.appendChild(script);

      // Clean up on unmount
      return () => {
        if (window.oneko && typeof window.oneko.destroy === 'function') {
          window.oneko.destroy();
        }
        if (document.getElementById('oneko-script')) {
          document.body.removeChild(document.getElementById('oneko-script'));
        }
      };
    } else {
      // If script already present, just clean up on unmount
      return () => {
        if (window.oneko && typeof window.oneko.destroy === 'function') {
          window.oneko.destroy();
        }
      };
    }
  }, []);
  return null;
}

function Background() {
  return (
    <div class="bg">
      <video autoPlay loop playsInline crossorigin="anonymous" muted width="100%" height="auto">
        <source src="https://harrisonc.cc/6s-night-time.webm" type="video/webm"></source>
      </video>
    </div>
  )
}

function Profile(){
  return (
    <div class="profile">
      <div class="header">
        <span class="name">Harrison Carpenter</span>
        <span class="contact">carpenhm@rose-hulman.edu</span>
      </div>
      <div class="socials">
        <GitHub />
        <LinkedIn />
        <Medium />
      </div>
    </div>
  )
}

function GitHub(){
  return (
    <div>
      <a class="link" target="_blank" href="https://github.com/rhit-carpenhm" rel="me">
          <svg class="icon github" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
						<path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"></path>
					</svg>
        <span class="tag">GitHub</span>
      </a>
    </div>
  )
}

function LinkedIn(){
  return (
    <div>
      <a class="link" target="_blank" href="https://www.linkedin.com/in/harrison-carpenter-a8a673345/" rel="me">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/>
        </svg>
        <span class="tag">LinkedIn</span>
      </a>
    </div>
  )
}

function Medium(){
  return (
    <div>
      <a class="link" target="_blank" href="https://medium.com/@harrison.m.carpenter" rel="me">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <g> <path fill="none" d="M0 0h24v24H0z"/> <path d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm13.3 12.94c-.1-.05-.15-.2-.15-.301V8.006c0-.1.05-.25.15-.351l.955-1.105V6.5H14.84l-2.56 6.478L9.366 6.5H5.852v.05l.903 1.256c.201.2.251.502.251.753v5.523c.05.302 0 .653-.15.954L5.5 16.894v.05h3.616v-.05L7.76 15.087c-.15-.302-.201-.603-.15-.954V9.11c.05.1.1.1.15.301l3.414 7.633h.05L14.54 8.76c-.05.3-.05.652-.05.904v5.925c0 .15-.05.25-.15.351l-1.005.954v.05h4.921v-.05l-.954-.954z"/> </g> </svg> 
      <span class="tag">Medium</span>
      </a>
    </div>
  )
}

function Navbar(){
  return (
    <div class="nav-bar">
      <a href="/" class={window.location.pathname=="/"?"selected":""}>Home</a>
      <a href="/projects" class={window.location.pathname=="/projects"?"selected":""}>Projects</a>
    </div>
  )
}

export default App;
